import { projectManagementApi } from '@/includes/projectManagementApi';

const pmCommitmentQualityService = {
  async getProjectCommitmentQuality(projectId) {
    const response = await projectManagementApi.get(
      `/projects/${projectId}/analytics/commitment-quality`,
    );
    return response.data;
  },
};

export default pmCommitmentQualityService;
